import { FormControl } from '@angular/forms';

/**
 * Lookup validators
 */
// @dynamic
export class LookupValidator {
	/**
	 * Makes the lookup required (Required = +value > 1)
	 */
	static get required() {
		return (control: FormControl) => {
			if (control.value && +control.value >= 1) {
				return null;
			} else {
				return { REQUIRED: true };
			}
		};
	}

	/**
	 * Makes the lookup required. works also if chosen value is not numeric
	 */
	static get requiredAnyType() {
		return (control: FormControl) => {
			if (control.value && (isNaN(+control.value) || +control.value >= 1)) {
				return null;
			} else {
				return { REQUIRED: true };
			}
		};
	}
}
